module.exports = __webpack_public_path__ + "media/images/brands/lilica_ripilica-096ab77ec2b963a7d31864f123ad1841.png";